module.exports = __webpack_public_path__ + "static/3-085f5f006eebbfdff6d211a8d0a99223.jpg";